// extracted by mini-css-extract-plugin
export default {"a1":"Ab2_a1__MmnOy","a11":"Ab2_a11__hrI2b","a12":"Ab2_a12__+dMnl","img":"Ab2_img__3SCWe","ih41":"Ab2_ih41__ahrr5","ih4":"Ab2_ih4__bVGNQ"};